// extracted by mini-css-extract-plugin
export var layoutContainer = "_61-0";
export var layoutContainerNoRounding = "_61-6";
export var layoutContainerOpen = "_61-5";
export var layoutContainerResizing = "_61-1";
export var mainContent = "_61-2";
export var resizeDivider = "_61-3";
export var slidePanel = "_61-4";